/**
 * An address typed into one box, one line per line, as the `lines` an
 * address carries (customer-address-spine 03 §15): split on line breaks only
 * (a comma inside a line stays in it), each line trimmed, blank lines dropped.
 *
 * How many lines an address may have is the server's rule, not this one's —
 * more than four comes back as a field error on `lines`.
 */
export function splitAddressLines(text: string): string[] {
  return text
    .split(/\r\n|\r|\n/)
    .map((line) => line.trim())
    .filter((line) => line !== "");
}
